
































import Vue from "vue";
import { mapState, mapGetters } from "vuex";

export default Vue.extend({
  components: {},
  data() {
    return {
      isCollapsed: false,
      courseFilter: "All",
      userId: 1,
      name: "Test",
      email: "test@gmail.com",
      phone: 111 - 111 - 1111,
    };
  },
  computed: {
    ...mapState("goal", ["loading"]),
    ...mapState("session", ["billingAccountIdChangedCount"]),
    ...mapState("session", ["user"]),
    hashTags() {
      let hashTags = ["All"];
      return [...new Set(hashTags)];
    },
  },
  watch: {
    billingAccountIdChangedCount(newVal) {
      //this.$store.dispatch("goal/getMyGoals", {});
    },
    user(newValue) {
      if (newValue) {
        (this as any).$intercom.boot({
          user_id: (this as any).user.id,
          user_hash: (this as any).user.intercomUserHash,
          name: (this as any).user.name,
          email: (this as any).user.emailAddress,
          phone: (this as any).user.phoneNumber,
        });
        (this as any).$intercom.show();
      }
    },
    email(email) {
      (this as any).$intercom.update({ email });
    },
  },
  created() {
    //this.$store.dispatch("goal/getMyGoals", {});
  },
  methods: {
    selectHandler(item) {
      this.courseFilter = item;
    },
  },
});
